import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setHeading } from "../../../redux/slice/headerSlice";
import ReferForm from "./ReferForm";
import {
  handleHowItWorksToggle,
  handlePrevBrandToggle,
  setHowItWorksToggleFalse,
  setprevBrandToggleFalse,
} from "../../../redux/slice/homeSlice";
import { AddReferralData, customerView, getreferralData } from "../../auth/auth";
import Loader from "../../partial/Loader";
import { getData } from "ajv/dist/compile/validate";
import { formatPoints, getDate } from "../../../utils/helper";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "../../layout/Header";
import { ValidatorForm } from "react-form-validator-core";
import TextValidator from "../../partial/TextValidator";
import swal from "sweetalert";

const ReferDistributor = () => {
  const formRef = useRef();
  const [loader, setLoader] = useState(true);
  const location = useLocation()
  const totalPoints = location?.state?.pointsData
  const [transactionList, setTransactionDetail] = useState([]);
  const dispatch = useDispatch();
  const howItWorksToggle = useSelector((state) => state.home.howItWorksToggle);
  const prevBrandToggle = useSelector((state) => state.home.prevBrandToggle);
  const [showPopup, setShowPopup] = useState(false);
  const [state, setState] = useState({
    customerid: localStorage.getItem("customerid"),
    refreetype: "Distributor",
    refreeename: "",
    refree_mobile: "",
    CreatedDate: new Date(),
    merchantcode: "MER000325",
  });
  const { refreeename, refree_mobile } = state;
  const onChange = (e) => {
    setState((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const onSubmit = async () => {
    setLoader(true);
    try {
      let token = await JSON.parse(localStorage.getItem("token_gen"));
      let response = await AddReferralData(token.access_token, state);
      setLoader(false);
      if (response?.message === "Success") {
        setShowPopup(true);
        setState({ ...state, refreeename: "", refree_mobile: "" });
      } else {
        swal({
          position: "center",
          icon: "error",
          title: response?.message,
          showConfirmButton: false,
          timer: 5000,
        });
      }
    } catch (error) {
      setLoader(false);
      swal({
        position: "center",
        icon: "error",
        title: "An error occurred. Please try again.",
        showConfirmButton: false,
        timer: 5000,
      });
    }
  };

  const handleClosePopup = (e) => {
    e.preventDefault();
    setShowPopup(false);
    navigate("/home");
  };


  useEffect(() => {
    return () => {
      dispatch(setHowItWorksToggleFalse());
      dispatch(setprevBrandToggleFalse());
    };

  }, []);
  const token = JSON.parse(localStorage.getItem("token_gen"));
  useEffect(() => {
    setLoader(true);
    const customerCode = localStorage.getItem("customercode");
    const customerPromise = customerView(token.access_token, customerCode);
    const customerid = localStorage.getItem("customerid");
    const referralData = getreferralData(token.access_token, "MER000325", customerid);

    Promise.all([customerPromise, referralData])
      .then(([profileData, referData]) => {
        const allreferData = referData.data || [];
        const allTransactions = profileData?.transactions || [];

        const retailerTransactions = allTransactions.filter(
          (transaction) =>
            transaction?.transactionDetail?.referred_type?.toLowerCase() === "distributor"
        );

        const referTransactions = allreferData.filter(
          (transaction) =>
            transaction?.refreetype?.toLowerCase() === "distributor"
        );

        const retailerMobiles = new Set(
          retailerTransactions.map(
            (transaction) => transaction?.transactionDetail?.mobile
          )
        );

        const referMobiles = new Set(
          referTransactions.map((transaction) => transaction?.refree_mobile)
        );

        const unmatchedReferTransactions = referTransactions.filter(
          (transaction) => !retailerMobiles.has(transaction?.refree_mobile)
        );

        // const unmatchedRetailerTransactions = retailerTransactions.filter(
        //   (transaction) => !referMobiles.has(transaction?.transactionDetail?.mobile)
        // );

        const mergedUnmatched = [...retailerTransactions, ...unmatchedReferTransactions];

        setTransactionDetail(mergedUnmatched);
      })
      .catch((error) => {
        console.error("Error in API calls", error);
      })
      .finally(() => {
        setLoader(false);
      });
  }, []);


  useEffect(() => {
    dispatch(setHeading("Refer a Distributor"));

  }, []);
  const navigate = useNavigate()
  const goToPreviousTab = () => {
    navigate(-1);
  };


  const activityPointsMap = {


    'Refer Distributors': {
      Silver: 500000,
      Gold: 1000000,
      Platinum: 1500000,
      "Founder Club": 2000000,
    },

  };

  const tierPoints = {
    Silver: '0.5%',
    Gold: '1%',
    Platinum: '1.5%',
    'Founder Club': '2%',
  };
  const tiers = localStorage.getItem("customerTier");

  return (
    <>
      <Header goToPreviousTab={goToPreviousTab} isHomePage={false} />
      <main>
        {loader && <Loader />}
        <div className="route-invoice yellowbg">
          <h4 className="route-invoice-top">
            <img src="/images/refr-distributor.png" alt="" />
            Refer a Distributor
          </h4>
          <p>
            Earn up to &#x20B9;{totalPoints}  for each
            successful distributor referral
          </p>
        </div>

        <div className="route-form">

          <ValidatorForm ref={formRef} onSubmit={onSubmit}>
            <div className="formbox">
              <span className="label">Distributor Name</span>
              <TextValidator
                placeholder="Enter distributor's business name"
                className="form-control"
                name="refreeename"
                maxLength="50"
                value={refreeename}
                type="text"
                onChange={onChange}
                validators={["required"]}
                errorMessages={["This field is required"]}
              />
            </div>
            <div className="formbox">
              <span className="label">Mobile Number</span>
              <TextValidator
                placeholder="Enter 10-digit mobile number"
                className="form-control"
                name="refree_mobile"
                maxLength="10"
                value={refree_mobile}
                type="text"
                onChange={onChange}
                validators={[
                  "required",
                  "matchRegexp:^(?!\\d*(\\d)\\1{7,}|0123456789|1234567890)\\d{10}$",
                ]}
                errorMessages={[
                  "This field is required",
                  "Please enter a valid number",
                ]}
              />
            </div>
            <div className="formbox">
              <button type="submit" className="btn btn-block btn-yellow-gold">
                Submit Referral
              </button>
            </div>
          </ValidatorForm>


        </div>
        {showPopup && (
          <div className="popup show" id="referral_successful">
            <div className="popup-box">
              <Link
                className="close-popup"
                id="close_referral_successful"
                onClick={handleClosePopup}
              >
                X
              </Link>
              <div className="popup-box-inner">
                <img src="/images/successful.png" className="success" alt="" />
                <h5 className="big">Referral Successful!</h5>
                <p className="small">
                  'As soon as your friend signs up, your reward rolls in' to- As soon as your friend gets onboarded, your points will get credited
                </p>
              </div>
            </div>
          </div>

        )}
        <div className="referral-brand">
          <div
            class={`referral-brand-heading ${prevBrandToggle ? "move" : ""}`}
            onClick={() => dispatch(handlePrevBrandToggle())}
          >
            Previously Referred Distributor
          </div>
          <div
            class={`referral-brand-results ${prevBrandToggle ? "active" : ""}`}
          >
            {transactionList && transactionList.length > 0 ? (
              transactionList.map((transaction) => (
                <div className="referral-brand-results-box" key={transaction.id}>
                  <div className="referral-brand-results-box-heading">
                    <div className="referral-brand-results-box-heading-left">
                      <span>
                        <img src="/images/referal-brands.png" alt="Referal Brands" />
                      </span>
                      <h5>{transaction?.transactionDetail?.refreeename || transaction?.refreeename}</h5>
                    </div>
                    <div className="referral-brand-results-box-heading-right">
                      <div className="referral-brand-status">
                        <p className={transaction?.transactionDetail?.is_onboarded.toLowerCase() === "onboarded" ? "onboarded" : transaction?.transactionDetail?.is_onboarded.toLowerCase() === "Not interested" ? "notinterested" : transaction?.transactionDetail?.is_onboarded.toLowerCase() === "Rejected" ? "rejected" : "inprogress"}>
                          {transaction?.transactionDetail?.is_onboarded.toLowerCase() === "onboarded" ? (
                            <i className="fa-regular fa-circle-check"></i>
                          ) : transaction?.transactionDetail?.is_onboarded.toLowerCase() === "Not interested" ? (
                            <i className="fa-regular fa-circle-xmark"></i>
                          ) : transaction?.transactionDetail?.is_onboarded.toLowerCase() === "Rejected" ? (
                            <i className="fa-solid fa-ban"></i>
                          ) : (
                            <i className="fa-regular fa-clock"></i>
                          )}
                          {transaction?.transactionDetail?.is_onboarded || "inprogress"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="referral-brand-results-box-bottom">
                    <p className="mb-04">Referred on {getDate(transaction?.transactionDetail?.referred_on, "DD-MMM-YYYY") || getDate(transaction?.CreatedDate, "DD-MMM-YYYY")}</p>
                    {transaction?.transactionDetail && <p className="reward">Earned {transaction?.transactionDetail?.points_Earned} point</p>}
                  </div>
                </div>
              ))
            ) : (
              <div className="no-data">
                <p>No Data Found</p>
              </div>
            )}


          </div>
        </div>
        <div className="how-it-works">
          <div
            class={`how-it-works-heading ${howItWorksToggle ? "move" : ""}`}
            onClick={() => dispatch(handleHowItWorksToggle())}
          >
            How it works
          </div>
          <div class={`how-it-works-results distri ${howItWorksToggle ? "active" : ""}`}>
            <ul>
              <li>
                Once you submit distributor details, our team connects with the
                distributor.
              </li>
              <li>
                After the distributor is onboarded, you become eligible for a
                referral bonus.
              </li>
              {/* <li>
              You can earn up to {formatPoints(tierPoints[tiers])}  of their 30 day throughput in money with
              Progcap, capped at {totalPoints} per distributor.
            </li> */}
              <li>You can earn points equal to their 30 day business volume with Progcap. Earn upto  &#x20B9;10K/distributor</li>
              <li>
                {/* Point can be redeemed after after 90 days if the Distributor is
              active & their retailers have not moved into overdue. */}

                Amount can be redeemed after 90 days if the Distributor is active & their buyers have not moved into overdue.

              </li>
            </ul>
          </div>
        </div>

        <div className="route-pushBox yellowbg mb-15">
          <div className="route-pushBox-left">
            <img src="/images/eligibility-criteria-icon.png" alt="" />
          </div>
          <div className="route-pushBox-right">
            <h4>Eligibility Criteria</h4>
            <p>
              Distributor should have a minimum annual turnover of ₹15Cr to be
              eligible for the program.
            </p>
          </div>
        </div>


      </main>
    </>
  );
};

export default ReferDistributor;
